import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';
import { ReactNode } from 'react';
import UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import useUser from '@alltrails/context/hooks/useUser';
import Typography from '@alltrails/core/components/Typography';
import Heading from '@alltrails/denali/components/Heading';
import PeakLogoBadge from '@alltrails/denali/components/SubscriptionBadge/Logo/Peak';
import { BREAKPOINT_SM_SIZE } from '@alltrails/denali/tokens';
import BaseUpsellModal from '../BaseUpsell/BaseUpsellModal';
import styles from '../FeatureUpsellModal.module.scss';
import getCtaText from '../getCtaText';
import PeakFeatureList from '../PeakFeatureList/PeakFeatureList';
import TierSubheading from '../UpsellContent/TierSubheading';

type Props = {
  customHeaderImage?: ReactNode;
  headerImageSrc: StaticImport;
  heading: ReactNode;
  isOpen: boolean;
  onCloseRequest: () => void;
  promoEligibleHeading: ReactNode;
  upsellTrigger: UpsellTrigger;
};

// https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=5543-297520&t=9h0uykTwgb7vGafI-0
export default function PeakFeatureUpsellModal({
  customHeaderImage,
  heading,
  promoEligibleHeading,
  onCloseRequest,
  headerImageSrc,
  isOpen,
  upsellTrigger
}: Props) {
  const user = useUser();
  const isPromoEligible = user?.isPromoEligible;

  return (
    <BaseUpsellModal
      headerImage={
        customHeaderImage ?? (
          <Image alt="" className={styles.image} sizes={`(max-width: ${BREAKPOINT_SM_SIZE}px) 100vw, 480px`} src={headerImageSrc} />
        )
      }
      heading={heading}
      isOpen={isOpen}
      onCloseRequest={onCloseRequest}
      primaryButtonText={getCtaText('peak', user?.isPromoEligible)}
      promoEligibleHeading={promoEligibleHeading}
      purchaseTier="peak"
      tallerOnMobile
      upsellTrigger={upsellTrigger}
      productsAvailable="peak"
    >
      <PeakLogoBadge size="md" variant="full" className={styles.logo} />
      <Heading as="h2" size="400">
        {isPromoEligible ? promoEligibleHeading : heading}
      </Heading>
      <Typography variant="text200">
        <TierSubheading tier="peak" />
      </Typography>
      <PeakFeatureList hasHeaderScrollMargin upsellTrigger={upsellTrigger} tierSelected="peak" />
    </BaseUpsellModal>
  );
}
